import * as React from 'react';

import './DetailLayout.scss';

const DetailLayout: React.FC = ({children}) => (
    <div className="detail-layout">
        <h2>Detail Layout ! </h2>
        {children}
    </div>
);

export default DetailLayout;
